import React from 'react';
import c from 'classnames';

import { UploadCard } from '../../../components/UploadCard';
import { FileComponentReadonlyProps } from '../types';
import { fileLink } from './style';

const FileComponentReadonly: React.FC<FileComponentReadonlyProps> = (props) => {
  const { href, name, size, type } = props;

  if (!href) {
    return null;
  }

  return (
    <div className="lygo-file">
      <div className="mt-16">
        <a
          className={c('w-full', fileLink)}
          href={href}
          rel="noreferrer noopener"
          target="_blank"
          title={name}>
          <UploadCard isUploading={false} name={name} size={size} type={type} />
        </a>
      </div>
    </div>
  );
};

export default FileComponentReadonly;
